import TagCloud from "TagCloud";
import React, { useEffect } from "react";
import "../../styles/Skill/Skill.scss";

const Skill = () => {
  useEffect(() => {
    const container = ".tagcloud";
    const texts = [
      "ReactJS",
      "Next.js",
      "Tailwind CSS",
      "Bootstrap",
      "Node.js",
      "Express",
      "MongoDB",
      "GraphQL",
      "Prisma",
      "Ktor",
      "Firebase",
      "REST APIs",
      "Docker",
      "Kubernetes",
      "GCP",
      "Datadog",
      "Grafana",
      "GitHub",
      "VSCode",
      "C++",
      "TypeScript",
      "Golang",
      "Kotlin",
      "SonarQube",
      "System Design",
    ];

    function radiusValue() {
      return window.screen.width <= 778 ? 180 : 290;
    }

    const options = {
      radius: radiusValue(),
      maxSpeed: "normal",
      initSpeed: "normal",
      keep: true,
    };

    if (!document.querySelector(".tagcloud").hasChildNodes()) {
      TagCloud(container, texts, options);
    }
  }, []);

  return (
    <div className="skill">
      <div className="skill__main-container">
        <div className="skill__header" id="skill__heading">
          <h1>
            {["S", "K", "I", "L", "L", "."].map((char, i) => (
              <span
                key={i}
                data-aos="fade-down"
                data-aos-delay={`${i * 200}`}
                data-aos-offset="200"
              >
                {char}
              </span>
            ))}
          </h1>
        </div>

        <div className="skill__inner-container">
          <div className="skill__info">
            <div className="skill__details-container">
              <div className="skill__details">
                <h4>Languages</h4>
                <ul>
                  <li><span>C++</span></li>
                  <li><span>C</span></li>
                  <li><span>JavaScript / TypeScript</span></li>
                  <li><span>Kotlin</span></li>
                  <li><span>Golang</span></li>
                </ul>
              </div>

              <div className="skill__details">
                <h4>Development Tools</h4>
                <ul>
                  <li><span>GitHub / Git</span></li>
                  <li><span>GitHub Copilot</span></li>
                  <li><span>VSCode / IntelliJ IDEA</span></li>
                  <li><span>SonarQube / SonarLint</span></li>
                  <li><span>Notion / DBeaver</span></li>
                </ul>
              </div>

              <div className="skill__details">
                <h4>Frontend</h4>
                <ul>
                  <li><span>ReactJS</span></li>
                  <li><span>Next.js</span></li>
                  <li><span>Tailwind CSS / Bootstrap</span></li>
                  <li><span>JavaScript Libraries</span></li>
                </ul>
              </div>

              <div className="skill__details">
                <h4>Backend</h4>
                <ul>
                  <li><span>Node.js / Express</span></li>
                  <li><span>Gin (Go)</span></li>
                  <li><span>MongoDB / Prisma ORM</span></li>
                  <li><span>GraphQL / REST APIs</span></li>
                  <li><span>Ktor / Firebase</span></li>
                  <li><span>JWT Authentication</span></li>
                </ul>
              </div>

              <div className="skill__details">
                <h4>Monitoring & DevOps Tools</h4>
                <ul>
                  <li><span>Grafana / Datadog</span></li>
                  <li><span>Docker / Kubernetes</span></li>
                  <li><span>ArgoCD</span></li>
                  <li><span>GCP</span></li>
                </ul>
              </div>

              <div className="skill__details">
                <h4>Other Technical Skills</h4>
                <ul>
                  <li><span>Data Structures & Algorithms (DSA)</span></li>
                  <li><span>Object-Oriented Programming (OOPs)</span></li>
                  <li><span>C++ STL / SQL / DBMS</span></li>
                  <li><span>Operating Systems (OS)</span></li>
                  <li><span>Jira / System Design</span></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="skill__cloud">
            <div
              className="tagcloud"
              data-aos="zoom-in-up"
              data-aos-offset="200"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skill;